import { ThemedText } from '@/components/themed-text';
import { Charge } from '@/types/charge';
import { CHARGE_STATUS } from '@/types/charge-status';
import { getEffectiveChargeStatus } from '@/utils/charge-status';
import { formatCurrency } from '@/utils/format-currency';
import { formatDate } from '@/utils/format-date';
import React from 'react';
import { GestureResponderEvent, TouchableOpacity, View } from 'react-native';

type ChargeItemProps = {
  charge: Charge;
  onPress: (event: GestureResponderEvent) => void;
  testID?: string;
};

const getStatusDetails = (status: CHARGE_STATUS) => {
  switch (status) {
    case CHARGE_STATUS.PAID:
      return { label: 'Pago', pill: 'bg-success-100', text: 'text-success-600' };
    case CHARGE_STATUS.PENDING:
      return { label: 'Pendente', pill: 'bg-warning-100', text: 'text-warning-600' };
    case CHARGE_STATUS.OVERDUE:
      return { label: 'Vencido', pill: 'bg-error-100', text: 'text-error-600' };
    case CHARGE_STATUS.CANCELED:
      return { label: 'Cancelado', pill: 'bg-neutral-100', text: 'text-neutral-500' };
    case CHARGE_STATUS.IN_DISPUTE:
      return { label: 'Em Disputa', pill: 'bg-warning-100', text: 'text-warning-600' };
    case CHARGE_STATUS.PAYMENT_REPORTED:
      return { label: 'Pagamento Informado', pill: 'bg-info-100', text: 'text-info-600' };
    default:
      return { label: status, pill: 'bg-neutral-100', text: 'text-neutral-500' };
  }
};

export function ChargeItem({ charge, onPress, testID }: ChargeItemProps) {
  const statusDetails = getStatusDetails(getEffectiveChargeStatus(charge));
  const formattedDueDate = formatDate(charge.dueDate) || '-';
  const formattedPaidAt = charge.paidAt ? formatDate(charge.paidAt) : null;

  return (
    <TouchableOpacity
      onPress={onPress}
      className="mb-2 w-full flex-row items-center justify-between gap-3 rounded-xl border border-neutral-200 bg-card px-4 py-3"
      style={{ borderCurve: 'continuous' }}
      activeOpacity={0.7}
      testID={testID}
    >
      <View className="flex-1 gap-1">
        <ThemedText className="font-semibold text-base text-foreground">
          {formatCurrency(charge.amount)}
        </ThemedText>
        <ThemedText className="text-xs text-neutral-500">
          Vencimento: {formattedDueDate}
        </ThemedText>
        {formattedPaidAt && (
          <ThemedText className="text-xs text-neutral-500">Pago em: {formattedPaidAt}</ThemedText>
        )}
      </View>
      <View className={`rounded-full px-3 py-1 ${statusDetails.pill}`}>
        <ThemedText className={`text-xs font-semibold ${statusDetails.text}`}>
          {statusDetails.label}
        </ThemedText>
      </View>
    </TouchableOpacity>
  );
}
